import { schAddressForm, schMLSID } from '@aloft/toolkit-shared';

import { z } from 'zod';

export type EditPropertyDetailsForm = typeof schEditPropertyDetailsForm;
export type EditPropertyDetailsFormOutput = z.infer<typeof schEditPropertyDetailsForm>;
export const schEditPropertyDetailsForm = z.strictObject({
  address: schAddressForm,
  mls: schMLSID.optional().or(z.literal('')),
  mlsListingID: z.string().optional(),
});
